// extracted by mini-css-extract-plugin
module.exports = {"sectionRow":"YGzcHlRi","titleBase":"pspzfJLC","bodySmall":"GgHo3hXV"};